import { CONTRACT_GROUP_STATUS, CUSTOM_FIELD_TYPE } from "src/api/contractGroup/contractgroup-type";

export const FIELD_TYPE_OPTIONS = [
  {
    label: "단일 선택",
    value: CUSTOM_FIELD_TYPE.RADIO,
  },
  {
    label: "다중선택",
    value: CUSTOM_FIELD_TYPE.CHECKBOX,
  },
  {
    label: "텍스트",
    value: CUSTOM_FIELD_TYPE.TEXT,
  },
  {
    label: "숫자",
    value: CUSTOM_FIELD_TYPE.NUMBER,
  },
  {
    label: "캘린더",
    value: CUSTOM_FIELD_TYPE.CALENDAR,
  },
  {
    label: "URL",
    value: CUSTOM_FIELD_TYPE.URL,
  },
];

// 계약그룹 상세 탭
export const CONTRACT_GROUP_TABS = [
  {
    label: "기본정보",
    value: "",
  },
  {
    label: "변경내역",
    value: "history",
  },
];

// 커스텀필드 페이지 탭 (변경내역 미제공)
export const CUSTOM_FIELD_TABS = [
  {
    label: "기본정보",
    value: "",
  },
];

// 계약그룹 상태 옵션
export const CONTRACT_GROUP_STATUS_OPTIONS = [
  { value: "", label: "전체" },
  { value: CONTRACT_GROUP_STATUS.NONE, label: "비어있음" },
  { value: CONTRACT_GROUP_STATUS.PLANNED, label: "이용예정" },
  { value: CONTRACT_GROUP_STATUS.ONGOING, label: "이용중" },
  { value: CONTRACT_GROUP_STATUS.COMPLETED, label: "이용종료" },
];
